export enum CheckOutState {
  IDLE = 'IDLE',
  DOING = 'DOING',
  DONE = 'DONE',
}
